module.exports = __webpack_public_path__ + "img/how-it-work-02.9f5be92d.png";